import {ApiConfigPort} from "./api-config-port";

// noinspection JSUnusedGlobalSymbols
export default class MasterBackendApiConfig implements ApiConfigPort {
    host: string = 'https://api.herds.alpacuna.com';
}